import Swal from "sweetalert2";
import * as actionTypes from '../actionTypes';
import { put, call, takeLeading } from 'redux-saga/effects';
import { getAPI } from '../../utils/api-function';
import { get_transaction_history } from '../../utils/api-routes';

function* getTransactionHistory(action) {
    const { payload } = action;
    console.log("Payload ::: ", payload)
    try {
        const { data } = yield getAPI(get_transaction_history((payload)));
        console.log("Get Transaction History Saga Response ::: ", data);
        if (data?.success) {
            yield put({ type: actionTypes.SET_TRANSACTION_HISTORY, payload: data });
        }

    } catch (error) {
        console.log("Get Transaction History Saga Error ::: ", error?.response?.data)
    }
}

export default function* transactionSaga() {
    yield takeLeading(actionTypes?.GET_TRANSACTION_HISTORY, getTransactionHistory);
}
